// Whether any duplicate-check criteria field on any leg has been modified
// from its saved value. Pairs with `excludeTripId` so editing non-criteria
// fields (price, notes, etc.) doesn't trigger the duplicate warning, while
// changes that could create a real conflict still do.

import type { FieldNamesMarkedBoolean } from 'react-hook-form';

import type { AddTripFormValues } from '../FormValues';

type DirtyFields = Partial<
  Readonly<FieldNamesMarkedBoolean<AddTripFormValues>>
>;

export function hasDuplicateCriteriaFieldsDirty(
  dirtyFields: DirtyFields
): boolean {
  const trips = dirtyFields.trips;
  if (!trips) return false;
  return trips.some(
    (t) =>
      t.pickupLocation?.address?.value ||
      t.dropoffLocation?.address?.value ||
      t.timing?.date ||
      t.timing?.pickup_time ||
      t.timing?.is_will_call
  );
}
